<script>
    export let paste

    import { user } from '../stores/login_store.js'
    import page from 'page'

    const delete_paste = async () => {
        await window.pb.paste_delete(paste.paste_id)
        page('/')
    }
</script>

<style>
    summary {
        cursor: pointer;
        margin-bottom: 1em;
        user-select: none;
    }
</style>

{#if $user && paste && paste.user_id === $user.user_id}
<details>
    <summary>controls</summary>
    <div class="box block">
        <div class="level">
            <div class="level-left">Ownership controls</div>
            <div class="level-right">
                <div class="buttons">
                    <!--button
                        class="button">
                        Extend timeout
                    </button-->
                    <button
                        on:click={delete_paste}
                        class="button is-danger">
                        Delete file
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</details>
{/if}
